import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "react-bootstrap";
import APIUrls from '../constants/ApiUrls';
import { APIManager } from "../utils/api";
import { copyToClipboard, MESSAGES } from "../utils/common";
import "./ItemDetailViewsTable.scss";

const EMPTY_DATA_SET = [{
  recipient: " - ",
  lastViewed: " - ",
  countViews: " - ",
}]
class ItemDetailViewsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userSharesInfo: []
    }
  }

  async componentDidMount() {
    if (!this.state.userSharesInfo || this.state.userSharesInfo.length === 0) {    
      const tokens = await this.props.Auth.currentSession();
      this.axiosConfig = {
        headers: {
          'Authorization': `Bearer ${tokens.accessToken.jwtToken}`,
          'X-Identity': tokens.idToken.jwtToken,
          "Content-Type": "application/json",
        },
        crossdomain: true
      };
      this.setState({ isLoading: true });
      let response = {};
      try {
        response = await APIManager.Instance.call("GET", APIUrls.getUserSharesForItem(this.props.itemId), this.axiosConfig);
        if (response && response.length > 0) {
          this.setState({ userSharesInfo: response, isLoading:false });
        } else {
          this.setState({ userSharesInfo: EMPTY_DATA_SET, isLoading:false });
        }
      } catch (e) {
        this.setState({ isLoading: false });
        console.log("Failed to get user shares info for item");
        return;
      }
    }
  }

  formatLinkCopyShare = (cell, row, rowIndex, formatExtraData) => {
    if (row && row.link) {
      return (
        <Button variant="outline-danger" className="mr-2" size="sm" 
          onClick={() => copyToClipboard(row.link, MESSAGES.URL_RECIPIENT_COPY)}>
            LINK
        </Button>
      )
    }
  }

  render() {
    return (
    <div className="detail-table">
      <BootstrapTable
        data={this.state.userSharesInfo}
        keyField="recipient"
        columns={[
          {
            dataField: "recipient",
            text: "Recipient",
            sort: true
          },
          {
            dataField: "lastViewed",
            text: "Last Viewed",
            sort: true
          },
          {
            dataField: "countViews",
            text: "Views",
            sort: true
          },
          {
            dataField: "copyShare",
            text: "",
            sort: false,
            formatter: this.formatLinkCopyShare
          },
        ]}
        bootstrap4={true}
        bordered={false}
      />
    </div>
          
    );
  }
}

export default ItemDetailViewsTable;
